import { Buffer } from 'buffer';
import Util from '../../../util/Util';
import axios from 'axios';
import { restClient } from '../../../axios';
import { Base64 } from '../../../util/Base64';

const logitechIntegrationURL = new Util().getLogitechIntegrationURL();
export default class CamerasCalls {
  restClient = restClient;

  getGroupCameras(groupId) {
    const url = `${logitechIntegrationURL}/${Base64.encode(groupId)}/cameras`;
    return this.restClient.get(url);
  }

  getPairableCameras(groupId) {
    const url = `${logitechIntegrationURL}/${Base64.encode(groupId)}/pairable`;
    return this.restClient.get(url);
  }

  pairCamera(groupId, camera) {
    const url = `${logitechIntegrationURL}/${Base64.encode(groupId)}/cameras`;
    const headers = {
      'Content-Type': 'application/json',
    };
    return this.restClient.callPromise({
      url,
      method: 'POST',
      headers,
      entity: camera,
    });
  }

  pairCameras(groupId, cameras) {
    const promises = cameras.map((camera) => this.pairCamera(groupId, camera));
    return Promise.all(promises).then((res) => res[0]);
  }

  getCameraImage(groupId, cameraID) {
    const url = `${logitechIntegrationURL}/${Base64.encode(
      groupId
    )}/cameras/${cameraID}/snapshot`;
    return axios.get(url, {
      withCredentials: false,
      headers: this.restClient.buildAuthHeader({}),
      responseType: 'arraybuffer',
    });
  }

  getCameraVideo(groupId, cameraID) {
    const url = `${logitechIntegrationURL}/${Base64.encode(
      groupId
    )}/cameras/${cameraID}/video`;
    return axios
      .get(url, {
        withCredentials: false,
        headers: this.restClient.buildAuthHeader({}),
        responseType: 'arraybuffer',
      })
      .then((response) => Buffer.from(response.data).toString('base64'));
  }

  getAuthURL(groupId) {
    const url = `${logitechIntegrationURL}/${Base64.encode(groupId)}/authorize`;
    return this.restClient.get(url);
  }
}
